import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from './auth.service';
import { TerminalsService } from './terminals.service';

@Injectable({
  providedIn: 'root'
})
export class TerminalsPollService implements OnDestroy {

  private readonly pollTimeInMS: number = 5000;
  private timerID: any; // NodeJs.Timeout
  public pollingStopped: boolean = false;
  private logoutEmitterSubscription: Subscription;

  constructor(private authService: AuthService, private terminalsService: TerminalsService) {
    this.logoutEmitterSubscription = authService.logoutEmitter.subscribe(logout => {
      this.pollHandling(logout);
    });
  }

  ngOnDestroy(): void {
    if (this.logoutEmitterSubscription) {
      this.logoutEmitterSubscription.unsubscribe();
    }
  }

  private pollHandling(logout: boolean) {
    if (!logout && this.authService.isLoggedIn) {
      this.restartPoll();
    } else {
      this.stopPollStatusList();
    }
  }

  private pollStatusList() {
    if (!this.timerID) {
      this.setStatusList();
      this.timerID = setInterval(() => {
        if (this.authService.isLoggedIn) {
          this.setStatusList();
        } else {
          this.stopPollStatusList();
        }
      }, this.pollTimeInMS);
    }
  }

  public stopPollStatusList() {
    clearInterval(this.timerID);
    this.timerID = null;
  }

  public restartPoll() {
    this.stopPollStatusList();
    if (!this.pollingStopped) {
      this.pollStatusList();
    }
  }

  private setStatusList() {
    this.terminalsService.updateTerminals();
  }

}
